import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type UnassignJourneyInput = {
  journeyId: string;
  assignmentId: string;
};

// DELETE /api/admin/journeys/:journeyId/assignments/:assignmentId
//
// Replaces /app/admin/journeys/_actions.ts::unassignJourneyAction. Pessimistic
// — ON DELETE CASCADE on journey_task_progress.assignment_id wipes the
// partner's progress rows for this journey atomically with the
// journey_assignments DELETE; partner-side state machines react best to a
// confirmed server result.
export function useUnassignJourney() {
  const queryClient = useQueryClient();
  return useMutation<null, ApiClientError, UnassignJourneyInput>({
    mutationFn: ({ journeyId, assignmentId }) =>
      apiFetch<null>(
        `/admin/journeys/${journeyId}/assignments/${assignmentId}`,
        { method: "DELETE" },
      ),
    onSuccess: (_data, { journeyId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.journeys.list() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.journeys.detail(journeyId),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.portal.journeys.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.portal.tasks.all });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to unassign journey");
    },
  });
}
